export default __webpack_public_path__ + "static/help-center-a3b4e1bd95dbe3a22f6ea125d53d1b70.jpg";